  document.addEventListener("DOMContentLoaded", function () {

observeWhatsApp()



      });
function observeWhatsApp() {
  const observer = new MutationObserver(() => {
    const whatsappLink = document.querySelector(".ysdWhatsappApp__sticky-btn a");

    if (whatsappLink) {
      setupWhatsApp(whatsappLink);
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}



      function setupWhatsApp(whatsappLink) {
  const urlParams = new URLSearchParams(window.location.search);


  console.log('inside')
  const paramsToTrack = ["utm_source"];

  const defaultParams = {
    utm_source: "Online",
  };

  // Store URL params
  paramsToTrack.forEach((param) => {
    if (urlParams.has(param)) {
      sessionStorage.setItem(param, urlParams.get(param));
    }
  });

  // -------- DETECT LANGUAGE --------
  const htmlLang = document.documentElement.lang;
  const path = window.location.pathname.toLowerCase();

  const isArabic =
    htmlLang === "ar" || path.includes("/ar") || path.startsWith("/ar/");

  // -------- PRODUCT MATRIX --------
  const productMap = {
    "/collections/outdoor-sofas-set": "outdoor sofas set",
    "/collections/new": "new arrivals",
    "/collections/outdoor-furniture-and-accessories": "outdoor furniture & accessories",
    "/collections/outdoor-lounge-furniture": "outdoor lounge furniture",
    "/collections/outdoor-bean-bags" :"outdoor bean bags",
    "/collections/outdoor-lounge-chairs" : "outdoor lounge chairs",
    "/collections/outdoor-dining-furniture" : "outdoor dining furniture",
    "/collections/outdoor-dining-sets":"outdoor dining sets",
    "/collections/outdoor-dining-tables" : "outdoor dining tables",
    "/collections/outdoor-chairs" : "outdoor chairs",
    "/collections/outdoor-coffee-and-side-tables" : "outdoor coffee & side tables",
    "/collections/outdoor-benches" : "outdoor benches",
    "/collections/parasols" : "parasols",
    "/collections/outdoor-cushions-and-accessories" : "outdoor cushions & accessories",
    "/collections/beach-and-camping-accessories" : "beach & camping accessories",
    "/collections/outdoor-rugs-and-carpets" : "outdoor rugs & carpets",
    "/collections/pool-accessories" : "pool accessories",
    "/collections/bars" : "bars",
    "/collections/fatboy-bean-bags" : "fatboy bean bags",
    "/collections/indoor-bean-bags" : "indoor bean bags",
    "/collections/kids-bean-bags" : "kids bean bags",
    "/collections/pet-beds" : "pet beds",
    "/collections/swing-and-stand-hammocks" : "swing & stand hammocks",
    "/collections/freestanding-hammocks" : "classic & freestanding hammocks",
    "/collections/hammock-chairs" : "hammock chairs",
    "/collections/classic-swing-hammocks" : "classic swing hammocks",
    "/collections/la-siesta-kids-hammocks" : "kids hammocks",
    "/collections/hammock-stands-and-suspension-kits" : "hammock stands & suspension kits",
    "/collections/cordless-and-rechargeable-table-lamps" : "cordless & rechargeable table lamps",
    "/collections/table-lights-and-lamps" : "indoor table lights & lamps",
    "/collections/outdoor-table-lights" : "outdoor table lights",
    "/collections/metal-table-lamps" : "metal table lamps",
    "/collections/glass-table-lamps" : "glass table lamps",
    "/collections/indoor-outdoor-lanterns-and-portable-lights" : "lanterns & portable lights",
    "/collections/outdoor-lighting" : "outdoor lighting & lamps",
    "/collections/solar-lights-outdoor" : "solar lights outdoor",
    "/collections/festival-lights" : "festival lights",
    "/collections/outdoor-floor-lamps" : "outdoor floor lamps",
    "/collections/pool-floating-lights" : "pool floating lights",
    "/collections/indoor-lighting" : "indoor lighting",
    "/collections/modern-floor-lamps" : "modern floor lamps",
    "/collections/neon-lights" : "kids & party lights",
    "/collections/bedroom-lights-and-night-lights" : "bedroom lights",
    "/collections/ceiling-lights" : "hanging & ceiling lights",
    "/collections/spares-and-accessories" : "replacement parts & accessories",
    "/collections/soy-tealight-and-rechargeable-led-candles" : "rechargeable LED candles",
    "/collections/modern-candle-holders" : "modern candle holders",
    "/collections/lit-bar-accessories" : "lit bar accessories",
    "/collections/home-furniture" : "furniture",
    "/collections/seating" : "seating",
    "/collections/indoor-sofas" : "sofas",
    "/collections/indoor-and-outdoor-lounge-chairs" : "indoor & outdoor lounge chairs",
    "/collections/dining-chairs" : "dining chairs",
    "/collections/poufs-and-ottomans" : "poufs & ottomans",
    "/collections/kids-chairs-stools" : "kids seating",
    "/collections/tables" : "tables",
    "/collections/coffee-and-side-tables" : "coffee & side tables",
    "/collections/dining-tables" : "outdoor dining tables",
    "/collections/dining-sets" : "dining sets",
    "/collections/trolleys-islands-bar-carts" : "trolleys, carts & islands",
    "/collections/indoor-and-outdoor-sofa-sets" : "sofa sets",
    "/collections/home-decor-and-accessories" : "home decor & accessories",
    "collections/home-accessories" : "accessories",
    "/collections/cushions-throws" : "cushions throws",
    "/collections/tote-bags-shopping-bags" : "tote bags & shopping bags",
    "/collections/rugs-and-carpets" : "rugs & carpets",
    "/collections/modern-candle-holders" : "modern candle holders",
    "/collections/soy-tealight-and-rechargeable-led-candles" : "rechargeable LED candles",
    "/collections/bar-accessories" : "bar accessories",
    "/collections/ceramics" : "kitchen products",
    "/collections/dutz" : "dutz",
    "/pages/fatboy" : "fatboy",
    "/pages/la-siesta" : "la siesta",
    "/collections/villeroy-boch" : "villeroy & boch",
    "/collections/sompex" : "sompex",
    "/pages/fermob" : "fermob furniture & lighting",
    "/pages/imagilights" : "imagilights",
    "/pages/filini-lighting" : "filini-lighting",
    "/pages/sirius-home" : "sirius home",
    "/collections/qult-candle-holders" : "qult candles",
    "/pages/slide" : "slide italy",
    "/collections/sonnenglas" : "sonnenglas",
    "/collections/humble-lights" : "humble lights",
    "/collections/moree" : "moree collection",
    "/pages/new-garden-lighting" : "new garden lighting",
    "/pages/maiori-lighting" : "maiori lighting",
    "/collections/yallah-lights" : "Yallah! lights",
    "/collections/furniture-warehouse-sale" : "warehouse sale",
  };

  let product = "furniture & lighting";

  for (let key in productMap) {
    if (path.includes(key)) {
      product = productMap[key];
      break;
    }
  }

  if (path.includes("/posts/")) {
    product = "furniture & lighting";
  }

  // -------- ARABIC TRANSLATIONS --------
  const arabicMap = {
    "wtwttwtwtwtwtwtwtwtbooking an appointment": "حجز موعد",
  };

  if (isArabic && arabicMap[product]) {
    product = arabicMap[product];
  }

  let utmSource =
    sessionStorage.getItem("utm_source") || defaultParams.utm_source;

  // -------- BUILD MESSAGE --------
  let message;

  if (isArabic) {
    message = `مرحبًا، أنا مهتم بـ ${product}. \n\n(Ref: ${utmSource})`;
  } else {
    message = `Hi, I am interested in ${product}. \n\n(Ref: ${utmSource})`;
  }

  console.log('inside')
  console.log(whatsappLink)
  // -------- BUILD WHATSAPP URL --------

  if (whatsappLink) {
    const phone = "971585517636";
    let finalParams = new URLSearchParams();

    finalParams.set("text", message);

    paramsToTrack.forEach((param) => {
      let value = sessionStorage.getItem(param) || defaultParams[param];
      if (value) finalParams.set(param, value);
    });

    // /send?phone=971585517636
    console.log('final')
    whatsappLink.setAttribute(
      "href",
      `https://wa.me/${phone}?${finalParams.toString()}`
    );
  }
}
